import axios from "axios";
import route from "../assets/apiRoutes.json";
import {alert, confirm} from 'devextreme/ui/dialog';

export const GridLayout = {
  sendStorageRequest (gridKey, method, accessToken, data, selectedLayout)
  {
    var url;

    if(method == "GET")
    {
      url = `${window._env_.REACT_APP_APIS}/${route.GridLayout.GetGridLayout}`
    }
    else
    {
      url = `${window._env_.REACT_APP_APIS}/${route.GridLayout.SaveUpdateGridLayout}`;
    }

    if (data) 
    {
      for (let i = 0; i < data?.columns?.length; i++) 
      {
        data.columns[i].filterValue = null;
      }

      data.selectedRowKeys = [];
      data.filterValue = null;
    }

    var requestOptions = {
      key: gridKey,
      name: selectedLayout,
      isDefault: selectedLayout==="Default"?true:false,
      isGlobalLayout: null,
      state: data ? JSON.stringify(data) : null
    };
      
    switch (method) 
    {
      case "POST":
        return axios
          .post(url, requestOptions, {
            headers: {
              "Content-Type": "application/json",
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then(response => {
            return response;
          })
          .catch(() => { throw 'Layout Save/Update Error'; });
        break;

      default:
        return axios
          .get(url, 
            {
              params: {
                key: gridKey,
                name: selectedLayout,
                isDefault: selectedLayout==="Default"?true:false,
              },
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              }
          })
          .then(response => {
            return JSON.parse(response.data.state);
          })
          .catch(() => { throw 'Layout Get Error'; });
        break;
    }
  },

  deleteGridLayout(dataGrid, selectedLayout, gridKey, accessToken) {
    if (selectedLayout == "Default") {
        alert('Cannot Delete Default Layout', 'Error');
        return Promise.resolve({deleteskipped:true});
    }
    else 
    {
      var result = confirm("<i>Are you sure you want to delete layout '" + selectedLayout + "' ?</i>", "Warning");
      return result.then(function (dialogResult) {
        if (dialogResult) 
        {
          dataGrid.current.instance().beginCustomLoading("Deleting Layout");
          return axios.post(
            `${window._env_.REACT_APP_APIS}/${route.GridLayout.DeleteGridLayout}`,
            { key: gridKey, name: selectedLayout },
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              }
            }
          ).then(response => {
            return response.data;
          })
          .catch(() => { dataGrid.current.instance().endCustomLoading(); throw 'Layout Delete Error'; });
        }
        else
        {
          return Promise.resolve({deleteskipped:true});
        }
      });
    }
}

};

